<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Perfil de Acesso</h4>
      </header>
      <div class="c-modalCard__body">
        <div v-for="role in roles" :key="role.code">
      <label>
        <input
          type="radio" 
          :value="role"
          v-model="selectedRole" 
        />
        {{ $t(`${role}.label`) }}
      </label>
    </div>
      </div>
      <footer class="c-modalCard__footer">
        <button type="button" class="btn" @click="close()">Cancelar</button>
        <button type="button" class="btn btn--success" @click="confirm()">Salvar</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  export default {
    data: () => ({
      modal: null,
      isVisible: false,
      roles: [
        'admin',
        'operator'
      ],
      selectedRole: null
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      callback: {
        type: Function,
        required: false
      },
      user: {
        type: Object,
        required: true
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')

      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      confirm () {
        this.$emit('saveUserRoles', this.selectedRole)
        this.close()
      },
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick
        this.isVisible = false
        this.selectedRole = this.user.role.identifier
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      },
      user (value) {
        if (this.user && this.user.role) {
          this.selectedRole = this.user.role.identifier
        } else {
          this.selectedRole = 'operator'
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ModalUserRoles.vue?5763fb49